import { Component } from "react"
import API, { URL_PATH } from "../../services/API"
import redux from "../../common/Redux"
import routes from "../../routes/URL"
import {
  Button,
  TextField,
  CardContent,
  CardHeader,
  Box,
  Typography,
  Container,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material"
import Toast from "../../components/Toast"
import Header from "../../components/Header"


class CreateTableScreen extends Component {
  constructor(props) {
    super(props)
    this.state = {
      type: "table", 
      toast: {
        open: false,
        message: "",
        severity: "success"
      }
    }
  }

  componentDidMount() {}
    showToast = (message, severity = "success") => {
    this.setState({
      toast: {
        open: true,
        message,
        severity
      }
    });
  };

  handleCloseToast = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({
      toast: {
        ...this.state.toast,
        open: false
      }
    });
  };

  handleTypeChange = (event) => {
    this.setState({ type: event.target.value })
  }

  create = async () => {
    const formdata = new FormData(document.getElementById("hotelForm"))
    formdata.append("hotel_floor_id", this.props.match.params.id)
    formdata.append("status", 0)
    formdata.append("type", this.state.type) // Ensure type is included in formdata
    console.log(formdata)
    const { status, message, data } = await API(this, "post", URL_PATH.createTable, formdata)

    if (status == "success") {
      this.showToast(message, "success");
          this.props.history.push(
      routes.admin.floors.show(
        this.props.match.params.hotelSlug,  // First param: hotelSlug
        this.props.match.params.floor,      // Second param: floor number
        this.props.match.params.id           // Third param: floor ID
      )
    );

    } else {
      this.showToast(message, "error");
      console.log("error");
    }
  }

  render() {
    const { isModalOpen, modalType, modalTitle, modalMessage, modalButtonText } = this.state

    return (
      <Container maxWidth="lg" className="py-5">
        <Box
          sx={{
            borderRadius: "10px",
            overflow: "hidden",
            bgcolor: "transparent",
            border: "1px solid #FFC857",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            p: 3,
          }}
        >
        

         <CardHeader
  title={
    <Box display="flex" alignItems="center" >
      <Header />
      <Typography variant="h5" fontWeight="500">
 Create Table/Room      </Typography>
    </Box>
  }
  sx={{ pb: 2 }}
/>
          <CardContent>
            <form
              id="hotelForm"
              name="hotelForm"
              onSubmit={(e) => {
                e.preventDefault()
                return this.create()
              }}
            >
              <Box mb={3}>
                <FormControl fullWidth>
                  <FormLabel id="type-radio-group-label" focused={false}>Type</FormLabel>
                  <RadioGroup
                    aria-labelledby="type-radio-group-label"
                    name="type"
                    value={this.state.type}
                    onChange={this.handleTypeChange}
                    row
                  >
                    <FormControlLabel
                      value="table"
                      control={
                        <Radio
                          sx={{
                            color: "#FFC857",
                            "&.Mui-checked": {
                              color: "#FFC857",
                            },
                          }}
                        />
                      }
                      label="Table"
                    />
                    <FormControlLabel
                      value="room"
                      control={
                        <Radio
                          sx={{
                            color: "#FFC857",
                            "&.Mui-checked": {
                              color: "#FFC857",
                            },
                          }}
                        />
                      }
                      label="Room"
                    />
                    {/* <FormControlLabel
                      value="bhall"
                      control={
                        <Radio
                          sx={{
                            color: "#FFC857",
                            "&.Mui-checked": {
                              color: "#FFC857",
                            },
                          }}
                        />
                      }
                      label="Birthday Hall"
                    /> */}
                  </RadioGroup>
                </FormControl>
              </Box>

              <Box mb={3}>
                <TextField
                  fullWidth
                  name="table_no"
                  label={`${this.state.type === "table" ? "Table" : this.state.type === "room" ? "Room" : "Birthday Hall"} Number`}
                  placeholder="Enter Number"
                  variant="outlined"
                  required
                />
              </Box>

              <Box mb={3}>
                <TextField
                  fullWidth
                  type="number"
                  name="table_capacity"
                  label={`${this.state.type === "table" ? "Table" : this.state.type === "room" ? "Room" : "Birthday Hall"} Capacity`}
                  placeholder="Enter Capacity"
                  variant="outlined"
                  required
                />
              </Box>

              <Box mt={4} display="flex" justifyContent="flex-start">
                <Button
                  variant="contained"
                  type="submit"
                  size="large"
                  sx={{
                    px: 4,
                    py: 1,
                    borderRadius: 1,
                    textTransform: "none",
                    fontWeight: 700,
                    bgcolor: "#FFC857",
                    "&:hover": { bgcolor: "#E6B54E" },
                  }}
                >
                  
                  SUBMIT
                </Button>
              </Box>
            </form>
          </CardContent>
        </Box>
        <Toast
        open={this.state.toast.open}
        message={this.state.toast.message}
        severity={this.state.toast.severity}
        onClose={this.handleCloseToast}
      />
      </Container>
    )
  }
}

export default redux(CreateTableScreen)

